import { render, staticRenderFns } from "./ModalNovidade.vue?vue&type=template&id=36d8ebcd&scoped=true"
import script from "./ModalNovidade.vue?vue&type=script&lang=js"
export * from "./ModalNovidade.vue?vue&type=script&lang=js"
import style0 from "./ModalNovidade.vue?vue&type=style&index=0&id=36d8ebcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d8ebcd",
  null
  
)

export default component.exports